import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { UserCog, Check } from "lucide-react";
import { ROLES, useRole } from "@/lib/roleContext";

export default function RoleSwitcher({ fullWidth = false }) {
    const { role, setRole, realRole } = useRole();
    // Dev-only impersonation: hide entirely from non-admins
    if (realRole !== "admin") return null;
    const active = ROLES.find((r) => r.id === role);

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                className={`pm-btn ${fullWidth ? "w-full" : ""}`}
                data-testid="role-switcher-trigger"
            >
                <UserCog className="w-4 h-4 mr-2" />
                <span className="text-xs">Role: {active?.label}</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="end"
                className="bg-[#141414] border-[#2a2a2a] rounded-none text-[#f4f4f0] w-64"
            >
                <DropdownMenuLabel className="font-mono text-[10px] uppercase tracking-widest text-[#666]">
                    Mock role (demo)
                </DropdownMenuLabel>
                <DropdownMenuSeparator className="bg-[#2a2a2a]" />
                {ROLES.map((r) => (
                    <DropdownMenuItem
                        key={r.id}
                        onClick={() => setRole(r.id)}
                        data-testid={`role-option-${r.id}`}
                        className="cursor-pointer rounded-none focus:bg-[#1f1f1f] focus:text-[#ff4400]"
                    >
                        <span className="flex-1 font-display font-bold uppercase tracking-wide text-sm">
                            {r.label}
                        </span>
                        {r.id === role && <Check className="w-4 h-4 text-[#ff4400]" />}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
